var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar wfill",style:({
    height: _vm.height + 'px'
  })},[(_vm.percentOf !== 0)?_c('div',{staticClass:"brown500 h10",style:({
      width: _vm.percentOf + '%',
      height: _vm.height + 'px'
    })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }